import apiInstance from "services/api/api";
import { IHydratedCatalog } from "shared/interfaces/Catalog.interface";
import { hydrateCatalog } from "shared/utils/catalog";

export default (restaurantId: string): Promise<IHydratedCatalog> =>
  apiInstance
    .get(`/catalogs/${restaurantId}`)
    .then((response) => hydrateCatalog(response.data.catalog));
